// ============================================
// AUTHENTICATED LAYOUT ROUTE
// ============================================

import { createFileRoute } from '@tanstack/react-router';
import { AdminLayout } from '@/layouts';

export const Route = createFileRoute('/_authenticated')({
  component: AdminLayout,
});
